// extracted by mini-css-extract-plugin
export default {"swiper-container":"q796V","swiper-container--align-center":"dhzPA","paginate-padding":"rj8fH","slide-width-auto":"lAsGP","swiper-slide":"ImEZk"};